<template>
  <v-row class="justify-start mb-4">
    <!-- Student Button -->
    <BaseButton
      :color="selectedCardType === 'student' ? 'primary' : ''"
      :outlined="selectedCardType !== 'student'"
      @click="chooseCard('student')"
      class="mr-4"
    >
      <v-icon left>mdi-account-student</v-icon> Student ID Card PAGE
    </BaseButton>

    <!-- Employee Button -->
    <BaseButton
      :color="selectedCardType === 'employee' ? 'primary' : ''"
      :outlined="selectedCardType !== 'employee'"
      @click="chooseCard('employee')"
      class="mr-4"
    >
      <v-icon left>mdi-account-badge</v-icon> Employee ID Card PAGE
    </BaseButton>
  </v-row>
</template>

<script setup>
import BaseButton from "@/components/Apps/cardSample/BaseButton.vue";
import { ref, defineEmits, onMounted } from "vue";

const emit = defineEmits(['studentType']);
const selectedCardType = ref("student");

const chooseCard = (cardType) => {
  selectedCardType.value = cardType;
  emit("studentType", cardType);
};
    
// onMounted(() => {
//   chooseCard("student");
//   console.log('chooseCard("student")', chooseCard("student"));
// });

</script>
